import { render } from "./Practice.vue?vue&type=template&id=7e18d85f"
import script from "./Practice.vue?vue&type=script&lang=js"
export * from "./Practice.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__